import { cn } from '@lib/utils';
import { XIcon } from 'lucide-react';
import { useCallback } from 'react';
import { Input } from './input';

type ClearableSearchInputProps = {
  className?: string;
  clearValue?: '' | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
  ref?: React.Ref<HTMLInputElement>;
  value: string | null;
};

export const ClearableSearchInput = (props: ClearableSearchInputProps) => {
  const { className, clearValue = '', onChange, placeholder = 'Search...', ref, value } = props;

  const handleClear = useCallback(() => {
    onChange(clearValue);
  }, [clearValue, onChange]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Escape') {
        handleClear();
      }
    },
    [handleClear],
  );

  const displayValue = value ?? '';
  const showClearButton = Boolean(value);

  return (
    <div className={cn('relative flex-1', className)}>
      <Input
        className="pr-8"
        onChange={(event) => onChange(event.target.value || clearValue)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        ref={ref}
        value={displayValue}
      />
      {showClearButton && (
        <button
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-gray-100"
          onClick={handleClear}
          type="button"
        >
          <XIcon className="size-4 text-gray-400" />
        </button>
      )}
    </div>
  );
};

ClearableSearchInput.displayName = 'ClearableSearchInput';
